import { render } from "./TheExportExcelButton.vue?vue&type=template&id=6cfc9587"
import script from "./TheExportExcelButton.vue?vue&type=script&lang=js"
export * from "./TheExportExcelButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__